/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useRef } from 'react';
import '@adyen/adyen-web/dist/adyen.css';
import AdyenCheckout from '@adyen/adyen-web';
import { Card } from 'primereact/card';
import { Fieldset } from 'primereact/fieldset';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import moment from 'moment';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import { showMessageError } from '../others/toastr';
import 'toastr/build/toastr.min.js';
import 'toastr/build/toastr.css';
import SourceAddress from '../../services/buscacep/helpers/sourceAddress';
import api from '../../services/backAxiosPagamentoToken';
import { Button } from 'primereact/button';
import ValorAdesaoDinheiro from './valorAdesaoDinheiro';
// import { StyleSheet } from '@react-pdf/renderer';
import { ProgressSpinner } from 'primereact/progressspinner';
import PagarComPix from '../pix/Pix';
import apiBack from '../../services/backAxios';
import '../../containers/home/styles.css';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const header = <img alt="Card" src={FundoAmarelo} />;
let quantidadeParcelasLiberadas = [1, 2];

const Pagamento = props => {
    const messages = useRef(null);
    const [isAssociado, setAssociado] = useState({});
    const [isAdesao, setAdesao] = useState({});
    const [isProgress, setProgress] = useState(false);
    const [sucesso, setSucesso] = useState(false);
    const [pagarPix, setPagarPix] = useState(false);
    const [pagarBoleto, setPagarBoleto] = useState(false);
    const [pagarDinheiro, setPagarDinheiro] = useState(false);
    const [pagarCartao, setPagarCartao] = useState(false);
    const [opcaoPagamento, setOpcaoPagamento] = useState(false);
    const [pagamentoRecorrente, setPagamentoRecorrente] = useState(false);
    const [valorInsc, setValorInsc] = useState(props.adesao);
    const dropin_container_ref = useRef();
    const voucher_container_ref = useRef();
    const { setResultCode, tipoCobranca } = props;
    const [loadingBoleto, setLoadingBoleto] = useState(false);
    const [loading, setLoading] = useState(false);
    const [overflowBoleto, setOverflowBoleto] = useState(false);
    const [erroCard, setErroCard] = useState(false);
    const [loadingPagamentoPix, setLoadingPagamentoPix] = useState(false);
    const [pagamentoAdesaoDinheiro, setPagamentoAdesaoDinheiro] = useState(false);
    const [quantidadeParcerlas, setQuantidadeParcerlas] = useState([]);

    const { fecharPopup, setOpenDialogSuccessPayment } = props;

    const styles = overflowBoleto ? {
        overflow: 'scroll',
        height: 430
    } : null;

    useEffect(() => {
        decriptoLocalStorage('area') === '3' && setPagamentoAdesaoDinheiro(true);

        const main = async () => {
            const { data } = await apiBack.get(
                `contratoEletronico/checaBaixaAdesao/${props.inscricao}`
            );

            const adesaoAserPaga = data ? 0 : `${Math.round(props.adesao * 100)}`;
            const sourceAddress = await new SourceAddress({
                postalCode: props.associado.CEPResid,
                houseNumber: props.associado.numeroResidencia,
                street: props.associado.Residencia
            });

            const { billingAddress } = await sourceAddress.init();
            const clientKey = retornoHashValor(process.env.REACT_APP_5);

            const valorQuery = {
                value: '2000',
                blockedPayment: ['scheme']
            };

            if (props.associado.AssTipoCobranca === 7) {
                valorQuery['blockedPayment'] = [
                    'boletobancario',
                    'boletobancario_santander',
                    'pix'
                ];
            }

            const paymentMethods = api
                .post('/list', valorQuery)
                .then(response => {
                    setLoading(false);

                    return response.data;
                })
                .catch(err => {
                    console.error(err);
                });

            const configuration = {
                paymentMethodsResponse: await paymentMethods,
                clientKey,
                locale: 'pt-BR',
                'translations': {
                    'pt-BR': {
                        'creditCard.holderName.placeholder': ' '
                    }
                },
                environment: retornoHashValor(process.env.REACT_APP_6),
                onSubmit: async (state, dropin) => {
                    const data = {
                        paymentData: state.data,
                        reference: '1',
                        inscricao: props.associado.Inscricao,
                        deliveryDate: moment().add(1, 'days').toISOString(),
                        value: adesaoAserPaga
                    };

                    if (state.data.paymentMethod.type === 'scheme') {
                        setProgress(false);

                        const cartao = await api
                            .post('/subscription', data)
                            .then(response => {
                                setProgress(true);

                                return response.data;
                            })
                            .catch(err => {
                                setProgress(true);

                                const errorCode =
                                    err.response.data.refusalReasonCode.toString();

                                if (errorCode === '20') {
                                    showMessageError(
                                        'Desculpe, Cartão recusado por algum erro nos dados',
                                        20
                                    );
                                    setErroCard(!erroCard);
                                } else if (errorCode === '24') {
                                    showMessageError('Ops! Códico CVC incorreto', 24);
                                    setErroCard(!erroCard);
                                } else {
                                    showMessageError('Ops! Erro desconhecido', 500);
                                    setErroCard(!erroCard);
                                }

                                return err;
                            });

                        if (cartao.resultCode === 'Authorised') {
                            setOpenDialogSuccessPayment(true);
                            fecharPopup(false);
                        }
                    } else {
                        const boleto = await api
                            .post('/boleto', data)
                            .then(response => {
                                setLoadingBoleto(false);
                                setOverflowBoleto(true);

                                return response.data;
                            })
                            .catch(err => {
                                console.error(err);
                            });

                        if (boleto.action) {
                            dropin.handleAction(boleto.action);
                        } else {
                            setResultCode(boleto.resultCode);
                        }
                    }
                },
                onAdditionalDetails: (state, dropin) => { }
            };

            const checkout = new AdyenCheckout(configuration);
            const dataBoleto =
                pagarBoleto || pagarCartao ?
                    checkout
                        .create('dropin', {
                            showPayButton: true,
                            amount: {
                                currency: 'BRL',
                                value: adesaoAserPaga
                            },
                            paymentMethodsConfiguration: {
                                boletobancario: {
                                    personalDetailsRequired: false,
                                    billingAddressRequired: false,
                                    showEmailAddress: false,
                                    data: {
                                        socialSecurityNumber: props.associado.CPF,
                                        firstName: props.associado.Nome,
                                        lastName: props.associado.Nome,
                                        billingAddress,
                                        shopperEmail: props.associado.AssEmail
                                    }
                                },
                                boletobancario_santander: {
                                    personalDetailsRequired: false,
                                    billingAddressRequired: false,
                                    showEmailAddress: false,

                                    data: {
                                        socialSecurityNumber: props.associado.CPF,
                                        firstName: props.associado.Nome,
                                        lastName: props.associado.Nome,
                                        billingAddress,
                                        shopperEmail: props.associado.AssEmail
                                    }
                                },
                                card: {
                                    hasHolderName: true,
                                    holderNameRequired: true,
                                    positionHolderNameOnTop: true,
                                    enableStoreDetails: false,
                                    showPayButton: true,
                                    installmentOptions: {
                                        card: {
                                            values: quantidadeParcerlas,

                                            plans: ['regular']
                                        },
                                        showInstallmentAmounts: true
                                    }
                                }
                            }
                        })
                        .mount(dropin_container_ref.current) :
                    null;
        };

        main();
    }, [setResultCode, pagarBoleto, pagarCartao, erroCard]);

    useEffect(() => {
        setAssociado(props.associado);
    }, []);

    const showAtivarRecorrencia = props.ativarRecorrencia;

    async function checaPagamento() {
        setLoadingPagamentoPix(true);

        const checaBaixaAdesao = await apiBack.get(
            `contratoEletronico/checaBaixaAdesao/${props.inscricao}`
        );
        const checaRecorrencia = await apiBack.get(
            `/associados-status/recorrencia/${props.inscricao}`
        );

        if (checaBaixaAdesao.data) {
            if (checaRecorrencia.data && checaRecorrencia.data.length) {
                mostrarMensagemErro('Esse contrato já possui uma recorrência ativa!');
                setLoadingPagamentoPix(false);
                setTimeout(() => {
                    document.location.reload();
                }, 5000);
            } else {
                setLoadingPagamentoPix(false);

                return onCardRecorrencia();
            }
        } else {
            setLoadingPagamentoPix(false);
            mostrarMensagemErro('É preciso realizar o pagamento para prosseguir.');
        }
    }

    function onCardPix() {
        setOpcaoPagamento(false);
        setPagamentoRecorrente(false);
        setPagarPix(true);
    }

    function onCardBoleto() {
        setOpcaoPagamento(false);
        setPagarBoleto(true);
        setLoading(true);
    }

    function onCardDinheiro() {
        setOpcaoPagamento(false);
        setPagarDinheiro(true);
    }

    function onCardRecorrencia() {
        if (isAssociado.SubGrupo.trim().substr(0, 2) === 'ZP') {
            quantidadeParcelasLiberadas = [1];

            setQuantidadeParcerlas(quantidadeParcelasLiberadas);
            setPagarPix(false);
            setPagamentoRecorrente(false);
            setPagarCartao(true);
            setLoading(true);
            setProgress(true);

            return;
        }

        setQuantidadeParcerlas(quantidadeParcelasLiberadas);
        setPagarPix(false);
        setPagamentoRecorrente(false);
        setPagarCartao(true);
        setLoading(true);
        setProgress(true);
    }

    const mensagemErro = useRef(null);

    function mostrarMensagemErro(values) {
        mensagemErro.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: values,
            life: 5000
        });
    }

    useEffect(() => {
        if (tipoCobranca === 7) {
            setPagamentoRecorrente(true);
        } else {
            setOpcaoPagamento(true);
        }
    }, []);

    return (
        <div>
            <Card className="tratar-scroll-card" header={header}>
                {isProgress && pagarCartao && (
                    <div>
                        <div className="content-section implementation">
                            <Fieldset legend="Forma de pagamento">
                                {loading && (
                                    <ProgressSpinner
                                        style={{
                                            width: '50px',
                                            height: '40px',
                                            display: 'flex',
                                            margin: '0 auto',
                                            marginTop: '5px'
                                        }}
                                    />
                                )}
                                <div
                                    className="p-grid p-justify-center"
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'row'
                                    }}
                                >
                                    {sucesso ? (
                                        <div className="p-col-12 p-md-12">
                                            <Message
                                                severity="success"
                                                text="Pagamento realizado com sucesso"
                                            />
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    <div className="p-col-align-center p-md-12">
                                        <div className="form">
                                            <div className="p-grid">
                                                <div className="p-md-4" />
                                                <div className="p-md-4">
                                                    <>
                                                        <div
                                                            ref={dropin_container_ref}
                                                            id="dropin-container"
                                                            style={{
                                                                width: '87%',
                                                                marginBottom: '20px'
                                                            }}
                                                        />

                                                        <div
                                                            ref={voucher_container_ref}
                                                        />
                                                    </>
                                                </div>
                                                <div className="p-md-4" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </div>
                )}

                {opcaoPagamento && (
                    <div>
                        <div className="content-section implementation">
                            <Fieldset legend="Forma de pagamento">
                                <div
                                    className="p-grid p-justify-center"
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'row'
                                    }}
                                >
                                    {sucesso ? (
                                        <div className="p-col-12 p-md-12">
                                            <Message
                                                severity="success"
                                                text="Pagamento realizado com sucesso"
                                            />
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    <div className="p-col-align-center p-md-12">
                                        <div className="form">
                                            <div className="p-grid">
                                                <div
                                                    className="p-md-12"
                                                    style={{
                                                        paddingLeft: '19%'
                                                    }}
                                                >
                                                    {!pagamentoAdesaoDinheiro && (
                                                        <Button
                                                            style={{
                                                                width: '50vw'
                                                            }}
                                                            label="Pagar Adesão em dinheiro"
                                                            className="p-button-success"
                                                            icon="pi pi-check"
                                                            onClick={onCardDinheiro}
                                                        />
                                                    )}

                                                    <Button
                                                        style={{
                                                            width: '50vw',
                                                            marginTop: '10px'
                                                        }}
                                                        label="Pagar Adesão em Boleto"
                                                        className="p-button-warning"
                                                        icon="pi pi-check"
                                                        onClick={onCardBoleto}
                                                    />
                                                    <Button
                                                        label="Pagar Adesão com Pix"
                                                        cursor="pointer"
                                                        className="botao p-button-info"
                                                        icon="pi pi-check"
                                                        onClick={onCardPix}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </div>
                )}

                {pagamentoRecorrente && !showAtivarRecorrencia && (
                    <div>
                        <div className="content-section implementation">
                            <Fieldset legend="Forma de pagamento">
                                <div
                                    className="p-grid p-justify-center"
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'row'
                                    }}
                                >
                                    <div className="p-col-align-center p-md-12">
                                        <div className="form">
                                            <div className="p-grid">
                                                <div
                                                    className="p-md-12"
                                                    style={{
                                                        paddingLeft: '19%'
                                                    }}
                                                >
                                                    <Button
                                                        style={{
                                                            width: '50vw'
                                                        }}
                                                        label="Pagar Adesão no Cartão e Ativar Recorrência "
                                                        className="p-button-success"
                                                        icon="pi pi-check"
                                                        onClick={onCardRecorrencia}
                                                    />
                                                    <Button
                                                        label="Pagar Adesão no Pix e Ativar Recorrência "
                                                        cursor="pointer"
                                                        className="botao p-button-info"
                                                        icon="pi pi-check"
                                                        onClick={onCardPix}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </div>
                )}
                {pagamentoRecorrente && showAtivarRecorrencia && (
                    <div>{onCardRecorrencia()}</div>
                )}
            </Card>

            {pagarBoleto && (
                <Card>
                    <div>
                        <div className="content-section implementation">
                            <Fieldset legend="Forma de pagamento">
                                <div
                                    className="p-grid p-justify-center"
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'row'
                                    }}
                                >
                                    {sucesso ? (
                                        <div className="p-col-12 p-md-12">
                                            <Message
                                                severity="success"
                                                text="Pagamento realizado com sucesso"
                                            />
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    <div className="p-col-align-center p-md-12">
                                        <div className="form">
                                            <div className="p-grid">
                                                <div className="p-md-4" />
                                                <div className="p-md-5" style={styles}>
                                                    <>
                                                        <div
                                                            ref={dropin_container_ref}
                                                            id="dropin-container"
                                                        />

                                                        <div
                                                            ref={voucher_container_ref}
                                                        />
                                                    </>
                                                    {loadingBoleto && (
                                                        <ProgressSpinner
                                                            style={{
                                                                width: '50px',
                                                                height: '40px',
                                                                display: 'flex',
                                                                margin: '0 auto',
                                                                marginTop: '5px'
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="p-md-3" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </div>
                </Card>
            )}
            {pagarDinheiro && (
                <Card>
                    <div>
                        <div className="p-col-align-center p-md-12">
                            <div className="form">
                                <div className="p-grid">
                                    <div className="p-md-4" />
                                    <div className="p-md-4">
                                        <ValorAdesaoDinheiro
                                            inscricao={props.inscricao}
                                            valor={valorInsc ? valorInsc : 0}
                                        />
                                    </div>
                                </div>
                                <div className="p-md-4" />
                            </div>
                        </div>
                    </div>
                </Card>
            )}
            {pagarPix && tipoCobranca !== 7 && (
                <Card>
                    <div className="flex">
                        <div className="p-col-align-center p-md-12">
                            <div className="form">
                                <div className="p-grid">
                                    <div className="p-md-4" />
                                    <div className="p-md-4">
                                        <PagarComPix inscricao={props.inscricao} />
                                    </div>
                                </div>
                                <div className="p-md-4" />
                            </div>
                        </div>
                    </div>
                </Card>
            )}
            {pagarPix && tipoCobranca == 7 && (
                <Card>
                    <div className="flex">
                        <div className="p-col-align-center p-md-12">
                            <div className="form">
                                <div className="p-grid">
                                    <div className="p-md-4" />
                                    <div className="p-md-4">
                                        <PagarComPix inscricao={props.inscricao} />
                                        <Button
                                            style={{
                                                marginTop: '10px'
                                            }}
                                            className="p-button-success"
                                            cursor="pointer"
                                            label="Prosseguir"
                                            icon={
                                                loadingPagamentoPix ?
                                                    'pi pi-spin pi-spinner' :
                                                    'pi pi-check'
                                            }
                                            onClick={checaPagamento}
                                        />
                                        <Growl ref={mensagemErro} />
                                    </div>
                                </div>
                                <div className="p-md-4" />
                            </div>
                        </div>
                    </div>
                </Card>
            )}
        </div>
    );
};

export default Pagamento;
